<script>
    import axios from "axios";
    export let showBuyMoreSpinsBtn;
    export let buyMoreSpinsUrl;
    export let availableSpins;
    export let collectedCodes;
    export let allPrizes;
    export let availablePrizes;

    $: totalPrizes = Object.keys(allPrizes).length;

    let wheel;
    let prizeInput;
    let rotating = false;
    let currentAngle = 0;
    let rotationTiming = 1 + Math.random() * (5 - 1);

    let slidePrizes = false;
    let currentPrize = 0;
    let currentPrizeString = null;

    let styles = {
        'rotation-timing': `${rotationTiming}s`,
    };

    $: cssVarStyles = Object.entries(styles)
        .map(([key, value]) => `--${key}:${value}`)
        .join(';');

    const axiosAPI = axios.create();
    const apiRequest = (method, url, request, headers = {}) => {
        //using the axios instance to perform the request that received from each http method
        return axiosAPI({
            method,
            url,
            data: request,
            headers
        }).then(res => {
            return Promise.resolve(res.data);
        })
            .catch(err => {
                return Promise.reject(err);
            });
    };
    const post = (url, request) => apiRequest("post", url, request, {
        'Content-Type': 'application/x-www-form-urlencoded',
    });

    function showPromocodeModal(code, description) {
        document.dispatchEvent(new CustomEvent('showPromocodeModalRequest', {
            detail: {
                code: code,
                description: description,
            }
        }));
    }


    function toggleRotation () {
        let angle = 0;
        const style = window.getComputedStyle(wheel, null);
        const transform = style.getPropertyValue("-webkit-transform") ||
            style.getPropertyValue("-moz-transform") ||
            style.getPropertyValue("-ms-transform") ||
            style.getPropertyValue("-o-transform") ||
            style.getPropertyValue("transform") ||
            'none';
        if (transform !== 'none') {
            const values = transform.split('(')[1].split(')')[0].split(',');

            const a = values[0]; // cos(X)
            const b = values[1]; // sin(X)
            const c = values[2]; // -sin(X)
            const d = values[3]; // cos(X)

            angle = Math.round(Math.asin(b) * (180/Math.PI));
            angle = angle >= 0 ? angle : 360 + angle;
        }

        let updatePrizesInterval;
        if (!rotating) {
            slidePrizes = true;

            updatePrizesInterval = setInterval(() => {
                currentPrize += 1;
                if (currentPrize >= Object.keys(availablePrizes).length) {
                    currentPrize = 0;
                }
                currentPrizeString = availablePrizes[Object.keys(availablePrizes)[currentPrize]];
            }, 100);
            const timeout = 5000 + Math.random() * (7000 - 5000);
            setTimeout(() => {
                clearInterval(updatePrizesInterval);
                document.dispatchEvent(new CustomEvent('prizeIdentified', {
                    detail: {
                        prizeCode: Object.keys(availablePrizes)[currentPrize],
                        prizeCodeString: currentPrizeString,
                    }
                }));

                collectedCodes = [...collectedCodes, Object.keys(availablePrizes)[currentPrize]];
                availableSpins -= 1;
                currentPrizeString = `✨ ${currentPrizeString} ✨`;
                toggleRotation();
                slidePrizes = false;
            }, timeout);
        }

        currentAngle = angle;
        rotating = !rotating;
    }

    function getPrize() {
        document.dispatchEvent(new CustomEvent('getPrizeRequest', {
            detail: {
                prizeCode: Object.keys(availablePrizes)[currentPrize],
                prizeCodeString: currentPrizeString,
            }
        }));
    }

</script>

<div class="fortune-wheel-wrap relative mx-auto block" style="{cssVarStyles}">
    <div class="wheel-wrap relative">
        <img src="/images/fortune-wheel/circle.svg"
             bind:this={wheel}
             alt="circle"
             class={rotating ? 'rotate-360' : ''}
             style="--wheel-angle: {currentAngle}deg; transform: rotate({currentAngle}deg);"
        />
    </div>
    <div class="marker-wrap absolute block">
        <img src="/images/fortune-wheel/marker.svg" alt="marker" />
    </div>
</div>

<div class="prize-container-wrap">
    <textarea type="text"
           bind:this={prizeInput}
           class="form-control h-64px-sm"
           style="text-align: center;"
           value={!currentPrizeString ? 'Ваш приз отобразится здесь... Вращайте колесо! :)' : currentPrizeString}
           disabled
    ></textarea>
</div>

<div class="controls-wrap text-center">
    {#if showBuyMoreSpinsBtn}
        <div class="row">
            <div class="col-md-6 mb-10px lg-text-right">
                    <button class="btn btn-success start-rotating" on:click={toggleRotation} disabled={rotating || (availableSpins === 0) || (totalPrizes <= collectedCodes.length) ? true : false}>
                        Вращать колесо
                    </button>
            </div>
            <div class="col-md-6 mb-10px lg-text-left">
                <a href={buyMoreSpinsUrl} class="btn btn-normal start-rotating">
                    Купить еще попытки
                </a>
            </div>
        </div>
    {:else }
        {#if currentPrizeString}
            <button class="btn btn-success start-rotating" on:click={getPrize} disabled={slidePrizes ? true : false}>
                Забрать свой приз
            </button>
        {:else }
            <button class="btn btn-success start-rotating" on:click={toggleRotation} disabled={rotating ? true : false}>
                Вращать колесо
            </button>
        {/if}
    {/if}
</div>

{#if (availableSpins !== null && showBuyMoreSpinsBtn)}
    {#if totalPrizes <= collectedCodes.length}
        <div class="spins-left-wrap text-center mb-10px">
            Отлично, вы выиграли все призы!
        </div>
    {:else }
        <div class="spins-left-wrap text-center mb-10px">
            Осталось попыток на сегодня: {availableSpins}
        </div>
    {/if}
{/if}

{#if (showBuyMoreSpinsBtn && collectedCodes.length > 0)}
    <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingOne">
            <h4 class="panel-title text-center">
                <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Список возможных и уже выигранных подарков
                </a>
            </h4>
        </div>
        <div id="collapseOne" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
            <div class="panel-body">
                {#each Object.keys(allPrizes) as code}
                    <div class="row">
                        <div class="mb-10px {collectedCodes.includes(code) ? 'col-md-10' : 'col-md-12 not-collected'}">{@html collectedCodes.includes(code) ? `<strong>✨ ${allPrizes[code]} ✨</strong>` : allPrizes[code]}</div>
                        {#if collectedCodes.includes(code)}
                            <div class="col-md-2 mb-10px text-center">
                                <a class="btn btn-sm btn-success" on:click={() => showPromocodeModal(code, allPrizes[code])}>
                                    Промокод
                                </a>
                            </div>
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
    </div>
{/if}

<style>
    .not-collected {
        color: grey;
    }
    .fortune-wheel-wrap {
        width: 224px;
        height: 263px;
        margin-bottom: 10px;
    }
    .prize-container-wrap {
        margin-bottom: 10px;
    }
    .start-rotating {
        min-width: 250px;
        width: 50%;
    }
    .marker-wrap {
        left: 85.5px;
        top: 188px;
    }

    .rotate-360 {
        animation: spin-360 infinite var(--rotation-timing) linear;
    }

    @keyframes spin-360 {
        from { transform: rotate(var(--wheel-angle)); }
        to { transform: rotate(calc(var(--wheel-angle) + 360deg)); }
    }
</style>